export interface applyToJobFace {
    [key: string]: string | any,
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
    cv: File,
    coverLetter: string | null
}

export enum QuestionTypes {
    YES_NO = 1,
    FREE_TEXT = 2,
    list = 3,
    file = 4,
}

export enum FieldsTypes {
    NumberInput = 1,
    TextArea = 2,
    Input = 3,
}

export interface IApplicationFormField {
    id: string,
    key: string,
    isEditable: boolean,
    isOptional: boolean,
    isEnabled: boolean,
    isDefault: boolean,
    placeholder?: string,
    options?: string[],
    typeId: QuestionTypes,
    additionalOptions?: {
        subTypeId?: FieldsTypes,
        regex?: string,
        errorMessage?: string
    }
}